import React from 'react';

const EventIcon = (props) => {

  const { size, color, className } = props;

  return (
    <div className={className}>
        <svg width={size} height={size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="6" cy="6" r="6" fill={color}/>
        </svg>
    </div>
    );
}

export default EventIcon;